import { render } from "./FeaturedJewellery.vue?vue&type=template&id=82053144"
import script from "./FeaturedJewellery.vue?vue&type=script&lang=js"
export * from "./FeaturedJewellery.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__